import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import Dashboard from "@/pages/Dashboard";
import InsightsDashboard from "@/pages/InsightsDashboard";
import ProjectsPage from "@/pages/ProjectsPage";
import TeamPage from "@/pages/TeamPage";
import ReportsPage from "@/pages/ReportsPage";
import AdminPage from "@/pages/AdminPage";
import { TagsProvider } from "./context/TagsContext";
import { FontProvider } from "./context/FontContext";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400 text-sm uppercase tracking-wider">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/tracker" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <FontProvider>
        <TagsProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            richColors
            toastOptions={{
              style: {
                background: "#1A1A1A",
                color: "#FFFFFF",
                border: "1px solid #1A1A1A",
                borderRadius: 0,
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: 13,
              },
            }}
          />
          <Routes>
            <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
            <Route path="/dashboard" element={<Protected><InsightsDashboard /></Protected>} />
            <Route path="/tracker" element={<Protected><Dashboard /></Protected>} />
            <Route path="/projects" element={<Protected><ProjectsPage /></Protected>} />
            <Route path="/team" element={<Protected><TeamPage /></Protected>} />
            <Route path="/reports" element={<Protected><ReportsPage /></Protected>} />
            <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
            <Route path="/" element={<Navigate to="/tracker" replace />} />
            <Route path="*" element={<Navigate to="/tracker" replace />} />
          </Routes>
        </BrowserRouter>
            </TagsProvider>
            </FontProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
